export const SEARCH_RADIUS_OPTIONS = [
  '5 miles',
  '10 miles',
  '15 miles',
  '20 miles',
  '25 miles',
]
